// extracted by mini-css-extract-plugin
export var heading = "v3-video-module--heading--dc8ad";
export var iframe = "v3-video-module--iframe--27032";
export var text = "v3-video-module--text--a8697";
export var videoContainer = "v3-video-module--videoContainer--3e176";